import styled from 'styled-components';
import upgradePlanBgImage from '../../../static/img/upgrade-plan-bg-image.png';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 30, 30, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: linear-gradient(180deg, #F5F2FF 0%, #B9A0F8 100%);
  border-radius: 16px;
  padding: 52px 32px 24px;
  box-sizing: border-box;
  max-height: calc(100vh - 32px); /* browsers without dvh (older iPads, Chromebooks) */
  max-height: calc(100dvh - 32px);
  
  width: 95%;
  max-width: min(1200px, calc(100vw - 40px));
  min-height: 0;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 700px) {
    width: calc(100vw - 24px);
    max-width: none;
    padding: 52px 16px 16px;
  }
`;

export const BackgroundPattern = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${upgradePlanBgImage});
  pointer-events: none;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-family: var(--font-family-ibm_plex_sans);
  z-index: 10;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;

export const UpgradeLabel = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #2E2277;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  position: relative;
  z-index: 5;
`;

export const ModalTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 32px 0;
  padding-top: 12px;
  text-align: center;
  font-family: var(--font-family-ibm_plex_sans);
  position: relative;
  z-index: 5;
`;

export const PlanGrid = styled.div`
  flex-shrink: 0;
  @media (max-width: 700px) { flex-direction: column; }
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 32px;
  position: relative;
  z-index: 5;
  overflow-x: hidden;
  overflow-y: visible;
  flex-wrap: nowrap;
  
  @media (max-width: 1440px) {
    gap: 20px;
  }
  
  @media (max-width: 1366px) {
    gap: 16px;
  }
  
  @media (max-width: 1280px) {
    gap: 12px;
  }
`;

export const PlanCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 0px 24px 24px 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  max-height: 70vh;
  overflow-y: auto;
  width: 372px;
  min-width: 0;
  flex: 0 1 372px;
  box-sizing: border-box;
  
  @media (max-width: 1440px) {
    flex: 0 1 calc(33.333% - 16px);
    width: auto;
  }
  
  @media (max-width: 1366px) {
    flex: 0 1 calc(33.333% - 12px);
    width: auto;
  }
  
  @media (max-width: 1280px) {
    flex: 0 1 calc(33.333% - 10px);
    width: auto;
  }
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  @media (max-width: 700px) {
    flex: none;
    width: 100%;
    max-height: none;
    overflow: visible;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
`;

export const PlanHeader = styled.div`
  width: calc(100% + 48px);
  margin: 0 -24px;
  border-radius: 0 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PlanLabel = styled.div`
  background: #2E2277;
  width: 100%;
  color: white;
  padding: 4px 12px;
  border-radius: 10px 10px 0 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  box-sizing: border-box;
`;

export const AllInclusiveLabel = styled.div`
  background: #2E2277;
  width: 100%;
  color: white;
  padding: 8px 12px;
  border-radius: 10px 10px 0 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  box-sizing: border-box;
  margin-bottom: -48px;
`;

export const PromoLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--color-Green-400, #005F3F);
  background: var(--color-Green-80, #E6F3EF);
  border: 1px solid var(--color-Green-90, #96CEBB);
  width: fit-content;
  margin: 10px auto -56px auto;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-sizing: border-box;
`;

export const PlanName = styled.h3`
  font-size: 48px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  padding-top: 80px;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const PlanSubtitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: var(--font-family-ibm_plex_sans); 
  margin: 4px 0;
`;

export const PlanPrice = styled.div`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color: #1a1a1a;
  margin: 8px 0;
`;

export const PlanToggle = styled.div`
  display: flex;
  background: #f3f4f6;
  border-radius: 30px;
  padding: 4px;
  border: 1px solid #FFFFFF
  gap: 4px;
  margin: 0 auto;
  width: fit-content;
  box-shadow: 0px 0px var(--elevationblur200) 0px #00000059 inset;
`;

export const ToggleButton = styled.button`
  flex: 1;
  padding: 8px 16px;
  border: none;
  border-radius: 30px;
  background: ${props => props.active ? '#2E2277' : 'transparent'};
  color: ${props => props.active ? 'white' : '#6b7280'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  

  
  &:hover {
    background: ${props => props.active ? '#2E2277' : 'rgba(46, 34, 119, 0.1)'};
  }
`;

export const PlanDescription = styled.p`
  font-size: 14px;
  color: #3E3B41;
  font-weight: 400;
  text-align: center;
  line-height: 1.5;
  margin: 0;
`;

export const PlanButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  
  ${props => {
    if (props.disabled) {
      return `
        border: 1px solid #9ca3af;
        color: #9ca3af;
        cursor: not-allowed;
      `;
    } else if (props.primary) {
      return `
        background: #2E2277;
        color: white;
        
        &:hover {
          background: #5a00b3;
        }
      `;
    } else if (props.secondary) {
      return `
        background: white;
        color: #2E2277;
        border: 2px solid #2E2277;
        
        &:hover {
          background: #f8f6ff;
        }
      `;
    }
  }}
`;

export const PlanFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  flex: 1;
  min-height: 0;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #000000;
`;

export const FeatureIcon = styled.span`
  color: #10b981;
  font-weight: bold;
  font-size: 16px;
`;
